import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from '../Utils';


// Emails
function pathViewEmailEditor(emailId=null) {
  if (emailId) {
      return `view/email-editor/${emailId}`;
  } else {
      return `view/email-editor`;
  }
}

export function getViewEmailEditor(successCallback, errorCallback, emailId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewEmailEditor(emailId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageEmails(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-emails`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageEmailConversions(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-email-conversions`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathEmails(emailId=null) {
  if (emailId) {
      return `emails/${emailId}`;
  } else {
      return `emails`;
  }
}

export function createEmails(successCallback, errorCallback, data) {
  postAuth({
    "path": pathEmails(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchEmails(successCallback, errorCallback, data, emailId) {
  patchAuth({
    "path": pathEmails(emailId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteEmails(successCallback, errorCallback, emailId) {
  deleteAuth({
    "path": pathEmails(emailId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postGeneratePlainTextEmails(successCallback, errorCallback, data) {
  postAuth({
    "path":  `emails/generate-plain-text`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}


export function postSendTestEmails(successCallback, errorCallback, data, emailId) {
  postAuth({
    "path": `emails/${emailId}/send-test`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function getViewEmailPreview(successCallback, errorCallback, instanceId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/email-preview/${instanceId}`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}



// Email Template
export function getViewManageEmailTemplates(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-email-templates`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathCustomEmailTemplates(templateId=null) {
  if (templateId) {
      return `custom-email-templates/${templateId}`;
  } else {
      return `custom-email-templates`;
  }
}

export function createCustomEmailTemplates(successCallback, errorCallback, data) {
  postAuth({
    "path": pathCustomEmailTemplates(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchCustomEmailTemplates(successCallback, errorCallback, data, templateId) {
  patchAuth({
    "path": pathCustomEmailTemplates(templateId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteCustomEmailTemplates(successCallback, errorCallback, templateId) {
  deleteAuth({
    "path": pathCustomEmailTemplates(templateId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathViewEmailTemplateEditor(templateId=null) {
  if (templateId) {
      return `view/email-template-editor/${templateId}`;
  } else {
      return `view/email-template-editor`;
  }
}

export function getViewEmailTemplateEditor(successCallback, errorCallback, templateId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewEmailTemplateEditor(templateId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Email Saved Block
function pathEmailSavedBlocks(blockId=null) {
  if (blockId) {
      return `email-saved-blocks/${blockId}`;
  } else {
      return `email-saved-blocks`;
  }
}

export function createEmailSavedBlocks(successCallback, errorCallback, data) {
  postAuth({
    "path": pathEmailSavedBlocks(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchEmailSavedBlocks(successCallback, errorCallback, data, blockId) {
  patchAuth({
    "path": pathEmailSavedBlocks(blockId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteEmailSavedBlocks(successCallback, errorCallback, blockId) {
  deleteAuth({
    "path": pathEmailSavedBlocks(blockId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Email Tag
export function getViewManageEmailTags(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-email-tags`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathEmailTags(tagId=null) {
  if (tagId) {
      return `email-tags/${tagId}`;
  } else {
      return `email-tags`;
  }
}

export function createEmailTags(successCallback, errorCallback, data) {
  postAuth({
    "path": pathEmailTags(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchEmailTags(successCallback, errorCallback, data, tagId) {
  patchAuth({
    "path": pathEmailTags(tagId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteEmailTags(successCallback, errorCallback, tagId) {
  deleteAuth({
    "path": pathEmailTags(tagId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Email Domains
function pathEmailDomains(domainId=null) {
  if (domainId) {
      return `email-domains/${domainId}`;
  } else {
      return `email-domains`;
  }
}

export function createEmailDomains(successCallback, errorCallback, data) {
  postAuth({
    "path": pathEmailDomains(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteEmailDomains(successCallback, errorCallback, domainId) {
  deleteAuth({
    "path": pathEmailDomains(domainId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postVerifyEmailDomains(successCallback, errorCallback, domainId) {
  postAuth({
    "path": `email-domains/${domainId}/verify`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageEmailDomains(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-email-domains`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function getViewEmailDomainDnsRecordsShforms(successCallback, errorCallback, domainId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/email-domain-dns-records-shforms/${domainId}`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}



// Email Profiles
function pathEmailProfiles(profileId=null) {
  if (profileId) {
      return `email-profiles/${profileId}`;
  } else {
      return `email-profiles`;
  }
}

export function createEmailProfiles(successCallback, errorCallback, data) {
  postAuth({
    "path": pathEmailProfiles(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchEmailProfiles(successCallback, errorCallback, data, profileId) {
  patchAuth({
    "path": pathEmailProfiles(profileId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteEmailProfiles(successCallback, errorCallback, profileId) {
  deleteAuth({
    "path": pathEmailProfiles(profileId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postResendEmailProfileVerification(successCallback, errorCallback, profileId) {
  postAuth({
    "path": `email-profiles/${profileId}/resend-verification`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageEmailProfiles(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-email-profiles`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathViewEmailProfileShforms(profileId=null) {
  if (profileId) {
      return `view/email-profile-shforms/${profileId}`;
  } else {
      return `view/email-profile-shforms`;
  }
}

export function getViewEmailProfileShforms(successCallback, errorCallback, profileId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewEmailProfileShforms(profileId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}



// Recipients
export function getViewManageEmailRecipients(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-email-recipients`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathEmailRecipients(recipientId=null) {
  if (recipientId) {
      return `email-recipients/${recipientId}`;
  } else {
      return `email-recipients`;
  }
}


export function deleteEmailRecipients(successCallback, errorCallback, recipientId) {
  deleteAuth({
    "path": pathEmailRecipients(recipientId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function postResendEmailRecipients(successCallback, errorCallback, recipientId) {
  postAuth({
    "path": `email-recipients/${recipientId}/resend`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function getViewEmailAnalytics(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/email-analytics`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export const URL_EMAIL_IMAGE_MEDIA = `/${constants.API_VERSION}/emails/image-media`;
export const URL_EMAIL_SOCIAL_CUSTOM_ICON_MEDIA = `/${constants.API_VERSION}/emails/social-custom-icon-media`;



// Email Settings
function pathViewEmailSettingsShforms() {
  return `view/email-settings-shforms`;
}

export function getViewEmailSettingsShforms(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewEmailSettingsShforms(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathViewEmailPreferencesEditor() {
  return `view/email-preferences-editor`;
}

export function getViewEmailPreferencesEditor(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewEmailPreferencesEditor(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathViewEmailSendingRulesShforms() {
  return `view/email-sending-rules-shforms`;
}

export function getViewEmailSendingRulesShforms(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewEmailSendingRulesShforms(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathEmailSettings() {
  return `email-settings`;
}

export function patchEmailSettings(successCallback, errorCallback, data) {
  patchAuth({
    "path": pathEmailSettings(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export const URL_EMAIL_SETTINGS_IMAGE_MEDIA = `/${constants.API_VERSION}/email-settings/image-media`;


function pathViewEmailDeliveryStatsShforms() {
  return `view/email-delivery-stats-shforms`;
}

export function getViewEmailDeliveryStatsShforms(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewEmailDeliveryStatsShforms(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// SMTP
function pathSmtpProfiles(profileId=null) {
  if (profileId) {
      return `smtp-profiles/${profileId}`;
  } else {
      return `smtp-profiles`;
  }
}

export function createSmtpProfiles(successCallback, errorCallback, data) {
  postAuth({
    "path": pathSmtpProfiles(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteSmtpProfiles(successCallback, errorCallback, profileId) {
  deleteAuth({
    "path": pathSmtpProfiles(profileId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postVerifySmtpProfilesDomain(successCallback, errorCallback, profileId) {
  postAuth({
    "path": `smtp-profiles/${profileId}/verify-domain`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageSmtpProfiles(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-smtp-profiles`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathViewSmtpProfileShforms(profileId=null) {
  if (profileId) {
      return `view/smtp-profile-shforms/${profileId}`;
  } else {
      return `view/smtp-profile-shforms`;
  }
}

export function getViewSmtpProfileShforms(successCallback, errorCallback, profileId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewSmtpProfileShforms(profileId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function getViewSmtpProfileDnsRecordsShforms(successCallback, errorCallback, profileId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/smtp-profile-dns-records-shforms/${profileId}`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}
